import { render, staticRenderFns } from "./form-component.vue?vue&type=template&id=681736b9&scoped=true"
import script from "./form-component.vue?vue&type=script&lang=js"
export * from "./form-component.vue?vue&type=script&lang=js"
import style0 from "./form-component.vue?vue&type=style&index=0&id=681736b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681736b9",
  null
  
)

export default component.exports